import React, { useMemo } from 'react';

export default function Sparkline({ data, width = 120, height = 40, strokeClass = "stroke-emerald-500" }: { data: number[]; width?: number; height?: number; strokeClass?: string }) {
    const path = useMemo(() => {
      if (!data || data.length === 0) return "";
      const min = Math.min(...data);
      const max = Math.max(...data);
      const norm = (v: number) => (max - min === 0 ? 0.5 : (v - min) / (max - min));
      return data
        .map((v, i) => {
          const x = (i / (data.length - 1)) * width;
          const y = height - norm(v) * height;
          return `${i === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`;
        })
        .join(" ");
    }, [data, width, height]);
  
    return (
      <svg width={width} height={height} className="overflow-visible">
        <path d={path} className={`${strokeClass} fill-none`} strokeWidth={2} />
      </svg>
    );
  }